module.exports = "../images/pano-background-wall-1.jpg";